import React, { useState } from 'react';
import Button from '@atlaskit/button';
import { InfoPanel } from '@css-xp/base';
import './success-banner.scss';

interface SuccessBannerProps {
  email: string;
  version?: number;
}

export const SuccessBanner = ({ email, version }: SuccessBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const message = React.useMemo(() => {
    let message = '';
    if (version === 2) {
      message = `Account created. An email has been sent to ${email} to finalise the sign up.`;
    } else {
      message = `Created Atlassian account for ${email}`;
    }

    return (
      <>
        <div>{message}</div>
        <Button
          appearance="link"
          testId={`dismiss-${email}`}
          onClick={() => {
            setIsVisible(false);
          }}
          spacing="none"
        >
          Dismiss
        </Button>
      </>
    );
  }, [email, version]);

  return isVisible ? (
    <div className="add-customer-success-banner" data-testid={`create-account-success-${email}`}>
      <InfoPanel
        type="success"
        {...(version !== 2 && { title: 'Atlassian account created' })}
        message={message}
      ></InfoPanel>
    </div>
  ) : null;
};
